import { Group } from "three";
const DISPLAY_PARAM_NAME = "display";
export class ChildrenDisplayController {
  constructor(node) {
    this.node = node;
    this._children_uuids_dict = /* @__PURE__ */ new Map();
    this._children_length = 0;
    this._sopGroup = this._createSopGroup();
  }
  _createSopGroup() {
    const group = new Group();
    group.matrixAutoUpdate = false;
    return group;
  }
  sopGroup() {
    return this._sopGroup;
  }
  setSopGroupName() {
    this._sopGroup.name = `${this.node.name()}:sopGroup`;
  }
  displayNodeControllerCallbacks() {
    return {
      onDisplayNodeRemove: () => {
        this.remove_children();
      },
      onDisplayNodeSet: () => {
        setTimeout(() => {
          this.request_display_node_container();
        }, 0);
      },
      onDisplayNodeUpdate: () => {
        this.request_display_node_container();
      }
    };
  }
  initializeNode() {
    var _a;
    this.node.object.add(this.sopGroup());
    this.node.nameController.add_post_set_fullPath_hook(this.setSopGroupName.bind(this));
    this._createSopGroup();
    const display_flag = (_a = this.node.flags) == null ? void 0 : _a.display;
    if (display_flag) {
      display_flag.onUpdate(() => {
        this._updateSopGroupHierarchy();
        if (display_flag.active()) {
          this.request_display_node_container();
        }
      });
    }
  }
  _updateSopGroupHierarchy() {
    var _a;
    const display_flag = (_a = this.node.flags) == null ? void 0 : _a.display;
    if (display_flag) {
      const sopGroup = this.sopGroup();
      if (this.usedInScene()) {
        sopGroup.visible = true;
        this.node.object.add(sopGroup);
        sopGroup.updateMatrix();
      } else {
        sopGroup.visible = false;
        this.node.object.remove(sopGroup);
      }
    }
  }
  usedInScene() {
    var _a, _b;
    const has_active_param = this.node.params.has(DISPLAY_PARAM_NAME);
    const is_active_param_on = this.node.params.boolean(DISPLAY_PARAM_NAME);
    const used_in_scene = this.node.usedInScene();
    const display_flag_on = ((_b = (_a = this.node.flags) == null ? void 0 : _a.display) == null ? void 0 : _b.active()) || false;
    const param_active_on = !has_active_param || is_active_param_on;
    return used_in_scene && display_flag_on && param_active_on;
  }
  async request_display_node_container() {
    if (!this.node.scene().loadingController.loaded()) {
      return;
    }
    if (this.usedInScene()) {
      await this._setContentUnderSopGroup();
    }
  }
  remove_children() {
    if (this._sopGroup.children.length == 0) {
      return;
    }
    let child;
    while (child = this._sopGroup.children[0]) {
      this._sopGroup.remove(child);
    }
    this._children_uuids_dict.clear();
    this._children_length = 0;
    this._notifyCamerasController();
  }
  async _setContentUnderSopGroup() {
    var _a;
    const display_node = this.node.displayNodeController.displayNode();
    if (display_node && ((_a = display_node.parent()) == null ? void 0 : _a.graphNodeId()) == this.node.graphNodeId()) {
      const container = await display_node.compute();
      const core_group = container.coreContent();
      if (core_group) {
        const new_objects = core_group.objects();
        let new_objects_are_different = new_objects.length != this._children_length;
        if (!new_objects_are_different) {
          for (let object of new_objects) {
            if (!this._children_uuids_dict.get(object.uuid)) {
              new_objects_are_different = true;
            }
          }
        }
        if (new_objects_are_different) {
          this.remove_children();
          for (let object of new_objects) {
            this._sopGroup.add(object);
            object.updateMatrix();
            this._children_uuids_dict.set(object.uuid, true);
          }
          this._children_length = new_objects.length;
        }
        this._notifyCamerasController();
        return;
      }
    }
    this.remove_children();
  }
  _notifyCamerasController() {
    this.node.scene().camerasController.updateFromChangeInObject(this._sopGroup);
  }
}
